/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar-week': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 1h2v2h8V1h2v2h1a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.11.89-2 2-2h1V1M5 7v12h14V7H5m2 2h10v2H7V9z"/>'
  }
})
